import { render, staticRenderFns } from "./ProjectTechnologyEditPage.vue?vue&type=template&id=247f670a&scoped=true&"
import script from "./ProjectTechnologyEditPage.vue?vue&type=script&lang=js&"
export * from "./ProjectTechnologyEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTechnologyEditPage.vue?vue&type=style&index=0&id=247f670a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f670a",
  null
  
)

export default component.exports